import { Phone, Mail, MapPin, Clock, ExternalLink } from "lucide-react";
import { Button } from "../components/ui/button";

export const Contact = () => {
  return (
    <div className="pt-20" data-testid="contact-page">
      {/* Hero Section */}
      <section className="py-24 md:py-32 bg-[#FAFAFA] border-b border-[#D4D4D4]" data-testid="contact-hero">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="max-w-4xl">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
              Contact
            </p>
            <h1 className="text-5xl sm:text-6xl font-black tracking-tighter uppercase mb-6">
              SUNTEM AICI<br />PENTRU TINE
            </h1>
            <p className="text-lg text-[#737373] max-w-2xl font-medium leading-relaxed">
              Ai întrebări sau vrei să plasezi o comandă? Contactează-ne prin telefon, email sau vizitează-ne la sediul nostru din Focșani.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-24 md:py-32 bg-white" data-testid="contact-info-section">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Details */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-12">
                INFORMAȚII DE CONTACT
              </h2>

              <div className="space-y-8">
                {/* Phone */}
                <div className="flex items-start gap-6" data-testid="contact-phone">
                  <div className="w-14 h-14 bg-[#FACC15] flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-[#0A0A0A]" />
                  </div>
                  <div>
                    <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                      Telefon Comenzi
                    </p>
                    <a 
                      href="tel:+40722344534" 
                      className="text-3xl md:text-4xl font-black text-[#0A0A0A] hover:text-[#FACC15] transition-colors"
                    >
                      +40 722 344 534
                    </a>
                    <p className="text-sm text-[#737373] mt-2">
                      Disponibil în programul de lucru
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-6" data-testid="contact-email">
                  <div className="w-14 h-14 bg-[#FACC15] flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-[#0A0A0A]" />
                  </div>
                  <div>
                    <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                      Email
                    </p>
                    <a 
                      href="mailto:office@solar-beton.ro" 
                      className="text-xl md:text-2xl font-bold text-[#0A0A0A] hover:text-[#FACC15] transition-colors"
                    >
                      office@solar-beton.ro
                    </a>
                    <p className="text-sm text-[#737373] mt-2">
                      Răspundem în maxim 24 de ore
                    </p>
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start gap-6" data-testid="contact-address">
                  <div className="w-14 h-14 bg-[#FACC15] flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-[#0A0A0A]" />
                  </div>
                  <div>
                    <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                      Adresă
                    </p>
                    <p className="text-xl md:text-2xl font-bold text-[#0A0A0A]">
                      Str. Vilcele Nr. 15 bis
                    </p>
                    <p className="text-lg text-[#0A0A0A]">
                      Focșani, Județul Vrancea
                    </p>
                    <p className="text-lg text-[#0A0A0A]">
                      România
                    </p>
                    <a 
                      href="https://maps.app.goo.gl/c5z1izVg4jxcjXXb6" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-sm text-[#FACC15] hover:text-yellow-500 mt-3 font-medium"
                    >
                      <ExternalLink className="w-4 h-4" />
                      Deschide în Google Maps
                    </a>
                  </div>
                </div>

                {/* Working Hours */}
                <div className="flex items-start gap-6" data-testid="contact-hours">
                  <div className="w-14 h-14 bg-[#FACC15] flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-[#0A0A0A]" />
                  </div>
                  <div>
                    <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                      Program de Lucru
                    </p>
                    <div className="space-y-2">
                      <div className="flex justify-between items-center border-b border-[#D4D4D4] pb-2 min-w-[250px]">
                        <span className="font-medium">Luni - Vineri</span>
                        <span className="font-bold text-[#FACC15]">07:30 - 16:30</span>
                      </div>
                      <div className="flex justify-between items-center border-b border-[#D4D4D4] pb-2">
                        <span className="font-medium">Sâmbătă</span>
                        <span className="text-[#737373]">Închis</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="font-medium">Duminică</span>
                        <span className="text-[#737373]">Închis</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Call Button */}
              <div className="mt-12">
                <Button 
                  asChild
                  className="bg-[#FACC15] text-[#0A0A0A] hover:bg-yellow-400 rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
                  data-testid="contact-call-btn"
                >
                  <a href="tel:+40722344534">
                    <Phone className="mr-2 w-5 h-5" />
                    Sună Acum pentru Comandă
                  </a>
                </Button>
              </div>
            </div>

            {/* Map */}
            <div className="h-[500px] lg:h-auto" data-testid="contact-map-container">
              <div className="h-full w-full bg-[#FAFAFA] border border-[#D4D4D4]">
                <iframe
                  src="https://maps.google.com/maps?q=Strada+Vilcele+15+bis,+Focsani,+Vrancea,+Romania&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="SC SOLAR CONSTRUCT SRL Location"
                  data-testid="contact-map"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Details */}
      <section className="py-16 bg-[#FAFAFA] border-t border-b border-[#D4D4D4]" data-testid="company-details-section">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center md:text-left">
              <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                Denumire Societate
              </p>
              <p className="font-bold text-lg">SC SOLAR CONSTRUCT SRL</p>
            </div>
            <div className="text-center md:text-left">
              <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                CUI
              </p>
              <p className="font-bold text-lg">RO14925112</p>
            </div>
            <div className="text-center md:text-left">
              <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#737373] mb-2">
                Nr. Reg. Comerțului
              </p>
              <p className="font-bold text-lg">J39/415/2002</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="contact-cta-section">
        <div className="px-6 md:px-12 lg:px-24 text-center">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
            Pregătit să Începi?
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6 text-white">
            COMANDĂ BETON DE CALITATE ASTĂZI
          </h2>
          <p className="text-lg text-white/60 mb-8 max-w-2xl mx-auto">
            Suntem aici să te ajutăm cu toate nevoile tale de beton. Sună-ne sau trimite un email pentru o ofertă personalizată.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+40722344534"
              className="inline-flex items-center justify-center bg-[#FACC15] text-[#0A0A0A] hover:bg-yellow-400 rounded-none font-bold tracking-wider uppercase text-sm px-8 py-4 transition-colors"
              data-testid="cta-phone-btn"
            >
              <Phone className="mr-2 w-5 h-5" />
              +40 722 344 534
            </a>
            <a 
              href="mailto:office@solar-beton.ro"
              className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#0A0A0A] rounded-none font-bold tracking-wider uppercase text-sm px-8 py-4 transition-colors"
              data-testid="cta-email-btn"
            >
              <Mail className="mr-2 w-5 h-5" />
              Trimite Email
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
